import { Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ProgressBar } from "../../../../shared/components/progress-bar/progress-bar";
import { ToBanglaNumberPipe } from '../../../../shared/pipes/toBanglaNumber.pipe';
import { TimeAgoPipe } from "../../../../shared/pipes/timeAgo.pipe";

@Component({
  selector: 'app-profile-stat-card',
  imports: [TranslocoModule, ProgressBar, ToBanglaNumberPipe, TimeAgoPipe],
  templateUrl: './profile-stat-card.html',
  styleUrl: './profile-stat-card.scss'
})
export class ProfileStatCard {
  percentage = input(0)
  days = input('')
  label = input('')
  redirectUrl = input('')
}
